'use client';

import { useAtomValue } from 'jotai';
import { Suspense, lazy } from 'react';

import { teamSeatUpgradeRequestModalAtom } from './atoms';

// `React.lazy`, not `next/dynamic`: this zone admits no `next/*` import.
const TeamSeatUpgradeRequestModalImplementation = lazy(() =>
  import('./team-seat-upgrade-request-modal-implementation').then((module) => ({
    default: module.TeamSeatUpgradeRequestModalImplementation,
  }))
);

/**
 * Lets a Scribe Team member ask their admins for a Practice seat. Mount once
 * app-wide; open with `openTeamSeatUpgradeRequestModalAtom`.
 *
 * Figma: https://www.figma.com/design/9LMl3feBFhljG6Ec8zVPpe?node-id=3182-114817
 */
export function TeamSeatUpgradeRequestModal() {
  const { isOpen } = useAtomValue(teamSeatUpgradeRequestModalAtom);
  if (!isOpen) return null;
  return (
    <Suspense fallback={null}>
      <TeamSeatUpgradeRequestModalImplementation />
    </Suspense>
  );
}
